(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sen-cyber-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__scyInit) return; window.__scyInit = true;
  var pad = function(n){ return (n < 10 ? '0' : '') + n; };

  function headerOffset(){ var h = document.querySelector('[data-scy-header].is-fixed'); return h ? h.offsetHeight + 8 : 8; }

  /* Scroll suave a anclas */
  document.addEventListener('click', function(e){
    var a = e.target.closest('.scy a[href^="#"]'); if(!a) return;
    var id = a.getAttribute('href').slice(1); if(!id) return;
    var t = document.getElementById(id); if(!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - headerOffset(), behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  /* Contadores */
  function tick(){
    document.querySelectorAll('[data-scy-countdown]').forEach(function(el){
      var end = Date.parse(el.dataset.end); if (isNaN(end)) return;
      var diff = Math.max(0, end - Date.now());
      if (diff <= 0){
        if (!el.classList.contains('is-over')){
          el.classList.add('is-over');
          if (el.hasAttribute('data-compact')) el.textContent = el.dataset.expired || '';
          else { var o = document.createElement('p'); o.className = 'scy-cd__over'; o.textContent = el.dataset.expired || ''; el.appendChild(o); }
        }
        return;
      }
      var d = Math.floor(diff/864e5), h = Math.floor(diff%864e5/36e5), m = Math.floor(diff%36e5/6e4), s = Math.floor(diff%6e4/1e3);
      if (el.hasAttribute('data-compact')) { el.textContent = 'Termina en ' + (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s); return; }
      var set = function(k,v){ var n = el.querySelector('[data-' + k + ']'); if(n) n.textContent = pad(v); };
      set('d', d); set('h', h); set('m', m); set('s', s);
    });
  }
  tick(); setInterval(tick, 1000);

  /* Header fijo + barra mobile */
  function initHeader(){
    var h = document.querySelector('[data-scy-header][data-sticky]');
    var sp = document.querySelector('[data-scy-spacer]');
    var bar = document.querySelector('[data-scy-mbar]');
    var hero = document.querySelector('.scy-hero');
    var start = h ? h.getBoundingClientRect().top + window.pageYOffset : 0;
    function onScroll(){
      var y = window.pageYOffset;
      if (h){
        var fix = y > start;
        if (fix && !h.classList.contains('is-fixed')){ sp.style.height = h.offsetHeight + 'px'; h.classList.add('is-fixed'); }
        else if (!fix && h.classList.contains('is-fixed')){ h.classList.remove('is-fixed'); sp.style.height = '0px'; }
      }
      if (bar){
        var limit = hero ? hero.offsetTop + hero.offsetHeight : 500;
        var nearEnd = (window.innerHeight + y) >= document.body.scrollHeight - 220;
        bar.classList.toggle('is-visible', y > limit && !nearEnd);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Filtros de grilla */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-scy-filter]'); if(!b) return;
    var wrap = b.closest('.scy-pgrid'); if(!wrap) return;
    wrap.querySelectorAll('[data-scy-filter]').forEach(function(x){ x.classList.toggle('is-active', x === b); });
    var q = b.dataset.scyFilter, re = null, n = 0;
    if (q) { try { re = new RegExp(q, 'i'); } catch(err) { re = null; } }
    wrap.querySelectorAll('[data-scy-grid] [data-scy-card]').forEach(function(c){
      var ok = !re || re.test(c.dataset.search || '');
      c.classList.toggle('is-hidden', !ok); if (ok) n++;
    });
    var em = wrap.querySelector('[data-scy-empty]'); if (em) em.hidden = n > 0;
  });

  /* Cambio de variante en tarjeta */
  document.addEventListener('change', function(e){
    var sel = e.target.closest('[data-scy-variant]'); if(!sel) return;
    var card = sel.closest('[data-scy-card]'), opt = sel.options[sel.selectedIndex];
    var btn = card.querySelector('[data-scy-add]'); if (btn) { btn.dataset.variant = sel.value; btn.disabled = opt.disabled; }
    var p = card.querySelector('[data-scy-price]'); if (p) p.textContent = opt.dataset.price;
    var c = card.querySelector('[data-scy-compare]'), sv = card.querySelector('[data-scy-save]'), pc = card.querySelector('[data-scy-pct]');
    if (c) { c.textContent = opt.dataset.compare || ''; c.hidden = !opt.dataset.compare; }
    if (sv) sv.hidden = true;
    if (pc) pc.hidden = !opt.dataset.compare;
  });

  /* Agregar al carrito (AJAX) y abrir carrito lateral */
  function updateCount(n){ document.querySelectorAll('[data-scy-count]').forEach(function(el){ el.textContent = n; el.hidden = !n; }); }
  async function openDrawer(sections){
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !sections || !sections['cart-drawer']) return false;
    try {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer'), cur = document.querySelector('#CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open(); else drawer.classList.add('active');
      return true;
    } catch(err) { return false; }
  }
  document.addEventListener('click', async function(e){
    var btn = e.target.closest('.scy [data-scy-add]'); if(!btn || btn.disabled || btn.dataset.busy) return;
    e.preventDefault();
    var txt = btn.textContent; btn.dataset.busy = '1'; btn.textContent = 'Agregando…';
    try {
      var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: 'cart-drawer' }) });
      var data = await res.json();
      if (!res.ok) { btn.textContent = (data && data.description) ? 'Sin stock suficiente' : 'Intenta de nuevo'; setTimeout(function(){ btn.textContent = txt; delete btn.dataset.busy; }, 2200); return; }
      btn.classList.add('is-added'); btn.textContent = '✓ Agregado';
      var root = btn.closest('[data-scy-root]');
      if (root && root.dataset.pixelAtc === 'true' && window.fbq) {
        var it = data.items && data.items[0];
        if (it) fbq('track', 'AddToCart', { content_ids: [String(it.variant_id)], content_type: 'product', value: it.final_line_price / 100, currency: 'CLP' });
      }
      try { var c = await (await fetch('/cart.js', { credentials: 'same-origin' })).json(); updateCount(c.item_count); } catch(err) {}
      var ok = await openDrawer(data.sections);
      if (!ok) { window.location.href = '/cart'; return; }
      setTimeout(function(){ btn.classList.remove('is-added'); btn.textContent = txt; delete btn.dataset.busy; }, 2200);
    } catch(err) {
      btn.textContent = txt; delete btn.dataset.busy;
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader); else initHeader();
})();

  } catch(e) { console.error(e); }
})();
})();
